import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import { blogPosts } from '../data/blogData'
import './blog.css'

const Blog = () => {
  const [activeFilter, setActiveFilter] = useState('ALL')

  const filterTabs = [
    { key: 'ALL', label: 'TÜM REHBERLER' },
    { key: 'PPF Kaplama', label: 'PPF KAPLAMA' },
    { key: 'Araç Kaplama', label: 'ARAÇ KAPLAMA' },
    { key: 'Seramik Kaplama', label: 'SERAMİK & BOYA' },
    { key: 'Detailing', label: 'İÇ & DIŞ DETAILING' },
  ]

  const filteredPosts =
    activeFilter === 'ALL'
      ? blogPosts
      : blogPosts.filter((p) => p.category === activeFilter)

  return (
    <div className="blog-page-container teleport-dashboard-layout">
      <SEO
        title="Detailing & Araç Bakım Rehberi Blog | ATEŞ AUTO DETAILING"
        description="PPF kaplama, seramik koruma, araç kaplama ve oto detailing dünyasından uzman tavsiyeleri, teknik bakım rehberleri ve bilgilendirici makaleler."
        canonicalPath="/blog"
      />

      <aside className="blog-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation />
      </aside>

      <main id="tq-main" className="blog-content-wrapper teleport-dashboard-content">
        <section className="blog-hero">
          <nav aria-label="Breadcrumb" className="blog-breadcrumb">
            <Link to="/">ANA SAYFA</Link>
            <span className="blog-breadcrumb-separator">/</span>
            <span aria-current="page">BLOG</span>
          </nav>

          <h1 className="blog-headline">Otomotiv Bakım ve Koruma Rehberi</h1>

          <p className="blog-description">
            Araç koruma teknolojileri, yüzey restorasyonu ve otomotiv estetiği üzerine teknik incelemeler,
            bakım standartları ve profesyonel detailing rehberleri.
          </p>
        </section>

        <section className="blog-body">
          {/* Kategori Filtre Butonları */}
          <div className="blog-filter-bar">
            {filterTabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`blog-filter-btn ${activeFilter === tab.key ? 'active' : ''}`}
                onClick={() => setActiveFilter(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Uzman Makaleleri Izgarası */}
          <div className="blog-articles-grid">
            {filteredPosts.map((post) => (
              <article key={post.slug} className="blog-card">
                <Link to={`/blog/${post.slug}`} className="blog-card-media-link" tabIndex="-1" aria-hidden="true">
                  <div className="blog-card-media-wrapper">
                    <img
                      src={post.image}
                      alt={post.imageAlt}
                      loading="lazy"
                      decoding="async"
                      className="blog-card-img"
                    />
                    <span className="blog-card-badge">{post.badge}</span>
                  </div>
                </Link>

                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-card-date">{post.publishDate}</span>
                    <span className="blog-card-dot">•</span>
                    <span className="blog-card-readtime">{post.readTime}</span>
                  </div>

                  <h2 className="blog-card-title">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h2>

                  <p className="blog-card-summary">{post.summary}</p>

                  <div className="blog-card-footer">
                    <Link to={`/blog/${post.slug}`} className="blog-read-action">
                      <span>Rehberi Oku</span>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Danışma & İletişim Kutusu */}
          <div className="blog-help-box">
            <div className="blog-help-content">
              <span className="blog-help-badge">ÖZEL STÜDYO DANIŞMANLIĞI</span>
              <h3 className="blog-help-title">Aracınız İçin Doğru Uygulamayı Belirleyelim</h3>
              <p className="blog-help-desc">
                Conrad Istanbul Bosphorus stüdyomuzda aracınızı yerinde inceleyerek vernik durumuna ve kullanım
                alışkanlıklarınıza en uygun koruma paketini birlikte planlayalım.
              </p>
            </div>
            <div className="blog-help-actions">
              <a
                href="https://wa.me/905346442153"
                target="_blank"
                rel="noreferrer noopener"
                className="blog-help-whatsapp-btn"
              >
                WhatsApp İle Danışın
              </a>
              <Link to="/iletisim" className="blog-help-contact-btn">
                Stüdyo Konumu &amp; İletişim
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export default Blog
